import moment from 'moment';
const patternSearch = /[.|,]+/g;

export const maximumSubString = maxLength => value => {
  if (value.toString().length < maxLength) return value;
  return value.substring(0, maxLength);
};

export const sleep = ms => {
  return new Promise(resolve => setTimeout(resolve, ms));
};

export const OnlyNumber = value => value.replace(/[^0-9]/g, '');

export const OnlyZeroOneNumber = value => value.replace(/[^01]/g, '');

export const isBefore = (initial, final) => moment(final).isSameOrBefore(moment(initial), 'day');

export const limitCedulaCharacters = value => value.toUpperCase().replace(/[^0-9aA]/g, '');

export const cleanCharactersInSearch = value => value.replace(patternSearch, '');

export const cleanSearch = value =>
  value
    .replace('?', '')
    .split('&')
    .reduce((acc, elem) => {
      const [name, value] = elem.split('=');
      if (!name) return acc;
      acc[name] = value;
      return acc;
    }, {});

export const isfirst = index => index.toString() === '0';

export const handleEnter = callback => event => {
  const { key } = event;
  if (key !== 'Enter') {
    return;
  }
  callback(event);
};

const cleanMoreSpaces = value =>
  value
    .split(' ')
    .filter(elem => elem !== '')
    .join(' ');

export const reduceSpaces = (acc, [key, val]) => {
  acc[key] = typeof val === 'string' ? cleanMoreSpaces(val).trim() : val;
  return acc;
};

export const removeSpaces = value => value.replace(/^[ ]+/g, '').replace(/[\\]+/g, '');

export const getFirstIndexWithValue = values => {
  let firstValue = 0;
  for (const [index, elem] of Object.entries(values)) {
    if (elem && elem.code) {
      firstValue = parseInt(index);
      break;
    }
  }
  return firstValue;
};

const cleanUpSpecialChars = str =>
  str
    .replace(/[ÀÁÂÃÄÅàáâãäå]/g, 'a')
    .replace(/[ÈÉÊËèéëê]/g, 'e')
    .replace(/[ÌÍÎÏíìïî]/g, 'i')
    .replace(/[ÔÒÓÖôöòó]/g, 'o')
    .replace(/[ÚÙÛÜúùüû]/g, 'u');

export const serviceFilterOption = (option, rawInput) => {
  const words = rawInput.split(' ');
  return words.reduce(
    (acc, cur) =>
      acc &&
      cleanUpSpecialChars(option.label.toLowerCase()).includes(
        cleanUpSpecialChars(cur.toLowerCase())
      ),
    true
  );
};

export const giveFormatOnPaste = ev => {
  if (ev.nativeEvent.inputType === 'insertFromPaste') {
    ev.target.blur();
    ev.target.focus();
  }
};
